import {Component, OnInit} from '@angular/core';
import {IAppState} from '../../store/state/app.state';
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import { HttpClient } from "@angular/common/http";
import {map} from 'rxjs/operators';
import {MS_15, traverseTree} from '../../common';
import {Router} from '@angular/router';
import {retryWithBackoff} from "../../../libs/rxjs/retryWithBackoff";
import {AccessService, StoreSelectorsService} from "../../services";
import {IEventBlock, IEventParam, IUser} from "../../interfaces";
import {Lib} from "../../../libs/Lib";
import {ToastrService} from "ngx-toastr";
import {Observable} from "rxjs";
import {actionSelectedSchedule} from '../../store/actions/user.actions';

interface SearchItem {
    type: string;
    text: string;
    link: string;
    redirect?: string;
    schedule_id?: string;
}

interface TreeData {
    name: string;
    iconname: string;
    url?: string;
    videoid?: string;
    children?: TreeData[];
}

@Component({
    selector: 'app-dialog-search',
    templateUrl: './dialog-search.component.html',
    styleUrls: ['./dialog-search.component.scss']
})
export class DialogSearchComponent extends Compbaser implements OnInit {
    searchResults: Array<SearchItem> = [];

    searchKey = "";
    appData: IAppState;
    filter = "";
    videoTreeData: TreeData[] = [];
    isLoading = true;
    filteredSearchResult: Array<SearchItem> = [];
    dashboard = false;
    eventBlocks: IEventBlock[] = [];
    eventParams: Array<IEventParam> = [];
    eventStrings: Array<string> = [];

    showHelp = false;
    canShowHelp = false;

    constructor(
        private storeSelector: StoreSelectorsService,
        private translocoService: TranslocoService,
        private accessService: AccessService,
        private toastr: ToastrService,
        private _http: HttpClient, private router: Router) {
        super();
    }

    ngOnInit(): void {
        this.isLoading = true;

        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    // Alon added that untill we support WL
                    const accountVersion = Lib.GetAccountVersion(i_user);
                    this.canShowHelp = (accountVersion == 'FREE' || accountVersion == 'PLUS' || accountVersion == 'DASH');
                })
        );


        this.cod( this.accessService.getGroupsCollection("SignStudio Help").subscribe( (value) => {
            this.showHelp = (value == null || value.$.visible == '1');
        }));

        this.cod(
            this.storeSelector.getAllEventsInSystemStructured()
                .subscribe((data) => {
                    this.eventStrings = data.eventStrings;
                    this.eventBlocks = data.eventBlocks;
                    this.eventParams = data.eventParams;
                })
        );
        this.cod(
            this.storeSelector.listenAllData().subscribe((i_appData: IAppState) => {
                this.appData = i_appData;
                this.dashboard = i_appData.users.selectedUser.dashboard;
            })
        );
        const local = this.translocoService.getActiveLang();
        const url = `./assets/vi18n/${local}.json?${Math.random()}`;
        this._http.request("GET", url, {responseType: "json"})
            .pipe(
                retryWithBackoff(url, this.storeSelector, this.toastr),
                map(data => data)
            )
            .subscribe(a => {
                const b = JSON.stringify(a).replace(/text/ig, 'name').replace(/icon/ig, 'iconname').replace(/Children/ig, 'children');
                const c = JSON.parse(b);
                traverseTree(c, (x, y, n) => {
                    if (x === 'state')
                        delete c['state'];
                    if (x === 'name' && n.iconname) {
                        n.iconname = 'insert_link';
                    }
                    if (x === 'name' && !n.iconname) {
                        n.iconname = 'insert_link';
                    }
                });
                this.videoTreeData = [c];
                this.isLoading = false;
            });
    }

    navigateSearchItem(item: SearchItem) {
        if (!item.link) return;

        // Handle scheduler selection via state before navigation
        if (item.type === 'scheduler' && item.schedule_id) {
            this.storeSelector.dispatch(actionSelectedSchedule({
                scheduleSelection: {
                    scheduler: {
                        scheduleId: item.schedule_id,
                        unique: Math.random()
                    }
                }
            }));
        }

        const skipChangeRoutings = ['help', 'user', 'privilege', 'adnet'];

        if (skipChangeRoutings.indexOf(item.type) > -1) {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
                // this.router.navigate([item.link])
                this.router.navigateByUrl(item.link)
            );
        } else {
            if (item.redirect) {
                this.router.navigateByUrl(item.redirect, {skipLocationChange: true});
                setTimeout(() => {
                    this.router.navigateByUrl(item.link);
                });
            } else {
                this.router.navigateByUrl(item.link);
            }
        }
    }

    // fire when click category filter
    setSearchFilter(val) {
        this.filter = this.filter == val ? '' : val;
        this.globalSearch();
    }

    // fire when change search of input
    changeSearchKey() {
        if (this.filter && this.searchResults.length > 0 && this.searchKey) {
            const key = this.searchKey.toLowerCase();
            this.filteredSearchResult = this.searchResults.filter((v) => v.text.toLowerCase().indexOf(key) > -1);
        } else {
            this.globalSearch();
        }
    }

    // clear search key by clicking "close" icon
    clearSearchKey() {
        this.searchKey = '';
        this.changeSearchKey();
    }

    private globalSearch() {
        this.searchResults = [];
        this.filteredSearchResult = [];

        if (this.isLoading || !this.appData) {
            return;
        }

        // if no filter and no search key or less than 3 chars
        if (!this.filter && (!this.searchKey || this.searchKey.length < 3)) {
            return;
        }

        const key = this.searchKey.toLowerCase();

        if (!this.dashboard) {
            if (!this.filter || this.filter === 'scene') {
                this.appData.users.scenes.forEach((i_scene) => {
                    if (i_scene.Player.$.label.toLowerCase().indexOf(key) > -1 ||
                        (i_scene.Player.$.mimeType && i_scene.Player.$.mimeType.toLowerCase().indexOf(key) > -1)) {

                        // Check if this is a slide (touch scene) or regular scene
                        const isSlide = i_scene.Player.$.mimeType === 'slides';

                        this.searchResults.push({
                            type: isSlide ? "slide" : "scene",
                            text: i_scene.Player.$.label,
                            link: isSlide ? "/editor/touch/scene/" + i_scene.Player.$.id : "/editor/scene/" + i_scene.Player.$.id
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'paint') {
                this.appData.users.painters.forEach((i_painter) => {
                    if (i_painter.painter_name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "paint",
                            text: i_painter.painter_name,
                            link: "/paint/edit/" + i_painter.id,
                            redirect: "/paint/list"
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'resource') {
                this.appData.users.resources.forEach((i_resource) => {
                    if (i_resource.resource_name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "resource",
                            text: i_resource.resource_name,
                            link: "resources/list?filter=" + i_resource.resource_name
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'player') {
                if (!this.appData.users?.stations) return;
                this.appData.users.stations.forEach((i_station) => {
                    if (i_station.station_name && i_station.station_name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "player",
                            text: i_station.station_name,
                            link: "stations?filter=" + i_station.station_name
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'event') {
                this.eventBlocks.forEach((i_event) => {
                    if (i_event.eventName.toLowerCase().indexOf(key) > -1) {
                        const o = Lib.Base64().encode(i_event.eventName);
                        this.searchResults.push({
                            type: "event",
                            text: `${i_event.eventName} (${i_event.eventType})`,
                            link: "/events/list?filter=" + o
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'catalog') {
                this.appData.users.catalogItems.forEach((i_catalog) => {
                    if (i_catalog.item_name && i_catalog.item_name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "catalog",
                            text: i_catalog.item_name,
                            link: "/catalog/list?filter=" + i_catalog.item_name
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'music') {
                this.appData.users.musicChannels.forEach((i_music) => {
                    if (i_music.music_channel_name && i_music.music_channel_name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "music",
                            text: i_music.music_channel_name,
                            link: "/music/list?filter=" + i_music.music_channel_name
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'scheduler') {
                this.appData.users.schedules.forEach((i_schedule) => {
                    if (i_schedule.schedule_name && i_schedule.schedule_name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "scheduler",
                            text: i_schedule.schedule_name,
                            link: "/scheduler/editor",
                            schedule_id: i_schedule.schedule_id
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'transition') {
                this.appData.users.transitionPools.forEach((i_transition) => {
                    if (i_transition.transition_pool_name && i_transition.transition_pool_name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "transition",
                            text: i_transition.transition_pool_name,
                            link: "/transitions/list?filter=" + i_transition.transition_pool_name
                        });
                    }
                });
            }
        } else {

            if (!this.filter || this.filter === 'player') {
                this.appData.enterprise.enterpriseStations?.forEach((i_station) => {
                    if (i_station.$.name && i_station.$.name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "player",
                            text: i_station.$.name,
                            link: "stations?filter=" + i_station.$.name
                        });
                    }
                });
            }
            if (!this.filter || this.filter === 'user') {
                this.appData.enterprise.enterpriseBusiness.Businesses.BusinessInfo.forEach((i_user) => {
                    if (i_user.$.name && i_user.$.name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "user",
                            text: i_user.$.name,
                            link: "/enterprise/users?filter=" + i_user.$.name
                        });
                    }
                });

            }

            if (!this.filter || this.filter === 'privilege') {
                this.appData.enterprise.enterpriseReseller.User.BusinessInfo[0].Privileges[0].Privilege.forEach((i_privilege) => {
                    if (i_privilege.$.name && i_privilege.$.name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "privilege",
                            text: i_privilege.$.name,
                            link: "/enterprise/privileges?filter=" + i_privilege.$.name
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'app') {
                this.appData.enterprise.enterpriseReseller.User.BusinessInfo[0].Apps[0].App.forEach((i_appCollection) => {
                    if (i_appCollection.$.appName && i_appCollection.$.appName.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "app",
                            text: i_appCollection.$.appName,
                            link: "/enterprise/apps?filter=" + i_appCollection.$.appName
                        });
                    }
                });
            }

            if (!this.filter || this.filter === 'adnet') {
                this.appData.enterprise.enterpriseBusiness.Businesses.BusinessInfo.forEach((i_businessAccount) => {
                    if (i_businessAccount.$.name && i_businessAccount.$.name.toLowerCase().indexOf(key) > -1) {
                        this.searchResults.push({
                            type: "adnet",
                            text: i_businessAccount.$.name,
                            link: "/adnet/manager?filter=" + i_businessAccount.$.name
                        });
                    }
                });
            }
        }

        if (!this.filter || this.filter === 'product') {
            this.appData.users.cart.products?.forEach((i_product) => {
                if (i_product.description && i_product.description.toLowerCase().indexOf(key) > -1 && i_product.product_id != MS_15) {
                    this.searchResults.push({
                        type: "product",
                        text: i_product.description,
                        link: "/shopping/products?s=p_" + i_product.product_id
                    });
                }
            });
        }

        if (this.showHelp && this.canShowHelp) {
            if (!this.filter || this.filter === 'help') {
                traverseTree(this.videoTreeData, (x, y, n) => {
                    if (n.videoid && n.name &&
                        n.name.toLowerCase().indexOf(key) > -1 &&
                        this.searchResults.findIndex((v) => v.link === "/help/" + n.videoid) === -1) {
                        this.searchResults.push({
                            type: "help",
                            text: n.name,
                            link: "/help/" + n.videoid
                        });
                    }
                });
            }
        }


        this.filteredSearchResult = this.searchResults;
    }
}
